module.exports = __webpack_public_path__ + "static/media/8OLA5.09baa14b.jpg";